import React from "react";

const StickyFooter = () => {
  return (
    <div
      className="text-center text-white py-2 fixed-bottom"
      style={{
        backgroundColor: "black",
        
        position:"sticky"
      }}
    >
     <h3 className="sticky-title "><span className="gradient-underline" >Last Date to Apply : </span> <span >30<sup>th</sup> July</span></h3>

    </div>
  );
};

export default StickyFooter;
